import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TooltipHost } from '@fluentui/react';
export function getTooltipSilentLogIn(element, isLoadingUserData) {
    const hostStyles = {
        root: {
            display: 'inline-block'
        }
    };
    const calloutProps = {
        gapSpace: 0,
        hidden: !isLoadingUserData
    };
    return /*#__PURE__*/ _jsx(TooltipHost, {
        styles: hostStyles,
        calloutProps: calloutProps,
        content: "Just a moment, logging you in...",
        children: element
    });
}
